import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FacetCheckboxGroupComponent } from "./facet-checkbox-group/facet-checkbox-group.component";
import { FacetRangeSliderComponent } from "./facet-range-slider/facet-range-slider.component";
import { PillsSearchResultsComponent } from "./pills-search-results/pills-search-results.component";
import { SearchResultsMobileToggleComponent } from "./search-results-mobile-toggle/search-results-mobile-toggle.component";
import { SearchResultsOwnerBannerComponent } from "./search-results-owner-banner/search-results-owner-banner.component";
import { SidebarSearchResultsComponent } from "./sidebar-search-results/sidebar-search-results.component";
import { SkeletonSearchResultsComponent } from "./skeleton-search-results/skeleton-search-results.component";
import { SharedModule } from "app/shared/shared.module";
import { SearchResultsFilterButtonComponent } from "./search-results-filter-button/search-results-filter-button.component";
import { SearchResultsFilterModalComponent } from "./search-results-filter-modal/search-results-filter-modal.component";

import { AccountModule } from "@rubbl-account";
import { RouterModule } from "@angular/router";
import { RangeSliderComponent } from "./range-slider/range-slider.component";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { RubblFormsModule } from "@rubbl-forms";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoreModule } from "@rubbl-core";
import { HeaderSearchResultsSearchDesktopComponent } from "./header-search-results-search-desktop/header-search-results-search-desktop.component";
import { RouterSidebarSearchResultsComponent } from "./router-sidebar-search-results/router-sidebar-search-results.component";
import { MachineCategoryMediaCardComponent } from "./machine-category-media-card/machine-category-media-card.component";
import { MachineCategoryMediaListComponent } from "./machine-category-media-list/machine-category-media-list.component";
import { V2TopbarSearchResultsSearchComponent } from "./v2-topbar-search-results-search/v2-topbar-search-results-search.component";
import { TopbarSearchResultsMakesComponent } from "./topbar-search-results-makes/topbar-search-results-makes.component";

@NgModule({
  declarations: [
    FacetCheckboxGroupComponent,
    FacetRangeSliderComponent,
    PillsSearchResultsComponent,
    SearchResultsMobileToggleComponent,
    SearchResultsOwnerBannerComponent,
    SidebarSearchResultsComponent,
    SkeletonSearchResultsComponent,
    SearchResultsFilterModalComponent,
    SearchResultsFilterButtonComponent,
    RangeSliderComponent,
    HeaderSearchResultsSearchDesktopComponent,
    RouterSidebarSearchResultsComponent,
    MachineCategoryMediaCardComponent,
    MachineCategoryMediaListComponent,
    V2TopbarSearchResultsSearchComponent,
    TopbarSearchResultsMakesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccountModule,
    FormsModule,
    ReactiveFormsModule,
    RubblFormsModule,
    RouterModule,
    NgxSliderModule,
    NgxSkeletonLoaderModule,
    CoreModule,
  ],
  exports: [
    FacetCheckboxGroupComponent,
    FacetRangeSliderComponent,
    PillsSearchResultsComponent,
    SearchResultsMobileToggleComponent,
    SearchResultsOwnerBannerComponent,
    SidebarSearchResultsComponent,
    SkeletonSearchResultsComponent,
    SearchResultsFilterModalComponent,
    SearchResultsFilterButtonComponent,
    HeaderSearchResultsSearchDesktopComponent,
    RouterSidebarSearchResultsComponent,
    V2TopbarSearchResultsSearchComponent,
  ],
})
export class SearchResultsSharedModule {}
